import store from 'store2';
import { KEY_EMAIL_EVENTS_STORAGE, KEY_EMAIL_INFO_STORAGE } from '~/constants';
import EE from '~/listenerEventService/EventEmitter';

export default class ClientEvents extends EE {
  EVENT_LISTENER_TYPES: ClientEventType[] = [
    'add-to-basket',
    'add-to-payment',
    'set-products-in-basket',
    'delete-from-basket',
    'change-items-count-in-basket',
    'clear-basket',
    'get-email',
  ];

  constructor() {
    super();
  }

  gunEmitClientEvent = (event: CustomEvent) => {
    this.emit('analytics', {
      type: event.type,
      ...event.detail,
    });
  }

  start() {
    this.EVENT_LISTENER_TYPES.forEach(type => 
      document.addEventListener(type, this.gunEmitClientEvent)
    );
  }
}
